let url = 'http://localhost:8000/api';
url = 'http://52.78.72.24/api';

if(process.env.NODE_ENV === 'production') {
    url = 'http://52.78.72.24/api';
}

export const BASE_URL = url;
